import { render, staticRenderFns } from "./SourceCodeContainer.vue?vue&type=template&id=596a725c&"
import script from "./SourceCodeContainer.vue?vue&type=script&lang=ts&"
export * from "./SourceCodeContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports